import { render, staticRenderFns } from "./latestNews.vue?vue&type=template&id=af2193ce"
import script from "./latestNews.vue?vue&type=script&lang=js"
export * from "./latestNews.vue?vue&type=script&lang=js"
import style0 from "./latestNews.vue?vue&type=style&index=0&id=af2193ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports